
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Wifi, WifiOff } from 'lucide-react';

interface RealtimeStatusIndicatorProps {
  isConnected: boolean;
  showLabel?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const RealtimeStatusIndicator: React.FC<RealtimeStatusIndicatorProps> = ({
  isConnected,
  showLabel = true,
  className = "",
  size = 'sm'
}) => {
  const sizeClasses = {
    sm: {
      dot: 'w-2 h-2',
      text: 'text-xs',
      icon: 12,
      gap: 'gap-2'
    },
    md: {
      dot: 'w-3 h-3',
      text: 'text-sm',
      icon: 16,
      gap: 'gap-3'
    },
    lg: {
      dot: 'w-4 h-4',
      text: 'text-base',
      icon: 20,
      gap: 'gap-4'
    }
  };

  const currentSize = sizeClasses[size];

  return (
    <div className={`flex items-center ${currentSize.gap} ${className}`}>
      <div className={`${currentSize.dot} rounded-full ${isConnected ? 'bg-green-500' : 'bg-gray-400'}`} />
      {showLabel && (
        <span className={`${currentSize.text} text-muted-foreground`}>
          {isConnected ? 'Live updates active' : 'Connecting...'}
        </span>
      )}
    </div>
  );
};

export default RealtimeStatusIndicator;
